import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      try {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'auto',
        });
      } catch (error) {
        // Fallback for older browsers
        window.scrollTo(0, 0);
      }
    };

    // Execute scroll on next tick after route change
    window.requestAnimationFrame(() => {
      scrollToTop();
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop; 